export default {
  mounted () {
    const { autofocus } = this.$refs
    if (autofocus) {
      const el = autofocus.$el.querySelector('input')
      el && el.focus()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/modals.js